import { useContext } from 'react';
import { Box } from '@mui/material';
import Utils from '../../../utils/Utils';
import styles from './BlockFullBleedImage.module.css';
import BlockProps from '../../../models/BlockProps';
import ImageComponent from '../../ImageComponent';
import { ImagesContext } from '../../../contexts/ImagesContext';
import ImageModal from '../../Modals/ImageModal/ImageModal';
import BlockFullBleedImageData from './BlockFullBleedImageData';

function BlockFullBleedImage({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockFullBleedImageData);
  const { images } = useContext(ImagesContext);
  return (
    <Box
      sx={{
        height: 350,
      }}
    >
      <Box
        className={styles.imageBoxContainer}
        sx={Utils.hoverBorder(isEditing, {
          height: '100%',
          position: 'static',
        })}
      >
        <ImageModal
          disabled={isTemplate || !isEditing}
          images={images}
          handleOnConfirm={(url: string) => {
            props.url.value = url;
            editHandler(data.id, props);
          }}
        >
          <ImageComponent src={props.url.value} />
        </ImageModal>
      </Box>
    </Box>
  );
}

export default BlockFullBleedImage;
